import React, { Component } from 'react'
import { connect } from 'react-redux'

import { selectVehicle } from '../../reducers'
import VehicleDetailsInfo from './vehicleDetailsInfo'
import VehicleDetailsSpecs from './vehicleDetailsSpecs'
import VehicleDetailsCarfax from './vehicleDetailsCarfax'
import VehicleDetailsOwner from './vehicleDetailsOwner'
import { fetchVehicle, overrideOwnership } from './vehiclesActions'
import { Vehicle } from '../../core/types'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  vehicle: Vehicle
  match: Match<ParamsID>
  fetchVehicle: Callback
  overrideOwnership: Callback
}

export class VehicleDetails extends Component<Props> {
  static displayName = 'VehicleDetails'

  componentWillMount() {
    const { fetchVehicle, match } = this.props
    fetchVehicle(match.params.id)
  }

  overrideOwnership() {
    const { vehicle, overrideOwnership } = this.props
    if (
      vehicle.latestOwnershipVerification.status !== 'VERIFIED' &&
      window.confirm('Are you sure you want to manually override ownership?')
    ) {
      overrideOwnership(vehicle.latestOwnershipVerification.user.id, vehicle.id)
    } else if (vehicle.latestOwnershipVerification.status === 'VERIFIED') {
      window.alert('User is already verified.')
    }
  }

  render() {
    const { vehicle } = this.props
    const { match } = this.props
    if (!vehicle) return null
    return (
      <div>
        <div className="vehicle-details">
          <div className="vehicle-details__container">
            <div className="vehicle-details__title">
              <h2>
                Vehicle ID: <a href="">{match.params.id}</a>
              </h2>
            </div>
            <VehicleDetailsInfo vehicle={vehicle} />
            <VehicleDetailsSpecs vehicle={vehicle} />
          </div>

          <div className="vehicle-details__container">
            <div className="vehicle-details__col">
              <VehicleDetailsOwner
                vehicle={vehicle}
                overrideOwnership={() => this.overrideOwnership()}
              />
            </div>
            <div className="vehicle-details__dbcol">
              <VehicleDetailsCarfax fraudCheck={vehicle.fraudCheck} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = (state, { match }) => {
  return {
    vehicle: selectVehicle(state.vehicles, match.params.id),
  }
}

export default connect(mapStateToProps, {
  fetchVehicle,
  overrideOwnership,
})(VehicleDetails)
